<template>
    <div>
        <div class="pl-3 pr-3 border-solid border-gray-200 border-2">
            <v-form ref="myform" v-model="isformvalid">
                <v-jsf v-model="formmodel" :schema="formschema" :options="formoptions">
                    <template slot="oscode" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.oscode" ref="fldfirst" maxlength="2" :readonly="fieldlocked"></v-text-field>
                    </template>
                    <template slot="osdesc" slot-scope="context">
                        <v-text-field v-bind="context" v-model="formmodel.osdesc" maxlength="255" :readonly="fieldlocked"></v-text-field>
                    </template>
                </v-jsf>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="newItem" v-if="mode === ''">
                        <v-icon left>mdi-text-box-plus-outline</v-icon>
                        New
                    </v-btn>
                    <v-btn color="blue darken-3" dark @click="savethis" v-if="mode !== ''">
                        <v-icon left>mdi-content-save</v-icon>
                        Update
                    </v-btn>
                    <v-btn color="red darken-3" dark @click="cancel" v-if="mode != ''">
                        <v-icon left>mdi-close</v-icon>
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-form>
        </div>
        <div class="pa-4 mt-3 border-solid border-gray-200 border-2">
            <v-data-table dense
                :headers="headers"
                :items="filtereddata()"
                item-key="id"
                v-model="selecteditems"
                show-select
                disable-pagination
                hide-default-footer
                no-data-text="No record"
                no-results-text="No record"
            >
                <template v-slot:[`header.oscode`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtoscode ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtoscode" label="Status Code" outlined></v-text-field>
                            <v-btn @click="txtoscode = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`header.osdesc`]="{ header }">
                    {{ header.text }}
                    <v-menu offset-y :close-on-content-click="false" min-width="300">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on">
                                <v-icon small :color="txtosdesc ? 'primary' : ''">mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <div class="bg-white pa-2">
                            <v-text-field v-model="txtosdesc" label="Description" outlined dense></v-text-field>
                            <v-btn @click="txtosdesc = ''" small text color="primary" class="ml-2 mb-2">Clear</v-btn>
                        </div>
                    </v-menu>
                </template>
                <template v-slot:[`item.no`]="{ item }">
                    <small>{{ dataitems.indexOf(item) + 1 }}</small>
                </template>
                <template v-slot:[`item.oscode`]="{ item }">
                    <small>{{ item.oscode }}</small>
                </template>
                <template v-slot:[`item.osdesc`]="{ item }">
                    <small>{{ item.osdesc }}</small>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon class="mr-2" small color="black" @click="editItem(item)">mdi-pencil</v-icon>
                    <v-icon color="black" small @click="deleteItem(item)">mdi-delete</v-icon>
                </template>
                <template v-slot:[`body.append`]>
                    <td colspan="6">
                        <v-select class="w-40 mt-3" :items="multifunctions" item-value="type" item-text="name" v-model="selmultifunc" placeholder="Bulk Operation" @change="execmfunc" dense/>
                    </td>
                </template>
            </v-data-table>
            <v-dialog v-model="dlgdelete" width="450" dark dense>
                <v-card dense>
                    <v-card-title class="title"><span class="text-white">Delete this record?</span></v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="4">No.</v-col>
                            <v-col cols="8">{{ deleteditem.no }}</v-col>
                            <v-col cols="4">Status Code</v-col>
                            <v-col cols="8">{{ deleteditem.oscode }}</v-col>
                            <v-col cols="4">Description</v-col>
                            <v-col cols="8">{{ deleteditem.osdesc }}</v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-3" dark @click="deletethis()">
                            <v-icon left>mdi-delete</v-icon>
                            Delete
                        </v-btn>
                        <v-btn color="red darken-3" dark @click="canceldelete">
                            <v-icon left>mdi-close</v-icon>
                            Cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <v-snackbar v-model="sbmsg" timeout="5000" color="green darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sbmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="sberrmsg" timeout="5000" color="red darken-4" dark centered>
            <div v-html="msg"></div>
            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="sberrmsg = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
const axios = require('axios')
import GeneralOptions from '../Forms/GeneralOptions'
import SystemOrderStatusModel from '../Forms/SystemOrderStatusModel'
import SystemOrderStatusSchema from '../Forms/SystemOrderStatusSchema'

export default {
    name: 'TableSystemOrderStatus',
    components: {},
    props: {},
    data() {
        return {
            isformvalid: false,
            formoptions: GeneralOptions,
            formmodel: SystemOrderStatusModel,
            formschema: SystemOrderStatusSchema,
            dataitems: [],
            headers: [
                { text: "No.",                  value: "no",        sortable: false, align: "start", width: '40px' },
                { text: "Status Code",          value: "oscode",    sortable: false },
                { text: "Status Description",   value: "osdesc",    sortable: false },
                { text: "Operations",           value: "actions",   sortable: false, align: 'end', width: '100px' }
            ],
            mode: null,
            editeditem: {
                no: 0,
                id: 0,
                oscode: '',
                osdesc: '',
            },
            deleteditem: {
                no: 0,
                id: 0,
                oscode: '',
                osdesc: '',
            },
            newitem: {
                oscode: '',
                osdesc: '',
            },
            dlgdelete: false,
            sbmsg: false,
            sberrmsg: false,
            msg: '',
            selecteditems: [],
            multifunctions: [
                // multi selection functions
                { type: null, name: 'Bulk Operation' }, // default
                { type: 'MDEL', name: 'Delete selected' },
            ],
            selmultifunc: null,
            ismounted: false,
            fieldlocked: false,
            txtoscode: '',
            txtosdesc: '',
        }
    },
    watch: {
        mode: function (newval, oldval) {
            if (newval === '')  {
                // lock the form entry
                this.lockallfields(true)
                return
            }
            if (((newval === 'NEW') || (newval === 'EDIT')) && (oldval === '')) {
                // unlock the form entry
                this.lockallfields(false)
                return
            }
        }
    },
    mounted: function () {
        this.initialize()
    },
    methods: {
        lockallfields(pSwitch) {
            this.fieldlocked = pSwitch // any custom field
            const vjsfprops = this.formschema.properties
            for (const field in vjsfprops) {
                if (vjsfprops[field]['x-props']) {
                    vjsfprops[field]['x-props']['readonly'] = pSwitch
                }
            }
        },

        initialize() {
            this.$nextTick(() => {
                this.getdata()
                this.ismounted = true
                this.mode = ''
                this.editeditem = Object.assign({}, this.newitem)
                this.formmodel = Object.assign({}, this.newitem)
                this.selecteditems = []
                this.multifunc = ''

                this.txtoscode = ''
                this.txtosdesc = ''
            })
        },

        getdata() {
            var targetPath = '/admin/system-order-status/all'
            axios.get(targetPath)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.dataitems = rtn.data
                    } else {
                        this.dataitems = []
                    }
                }
            })
        },

        filtereddata() {
            var conditions = []

            if (this.txtordesc) { conditions.push(this.filteroscode) }
            if (this.txtorprice) { conditions.push(this.filterosdesc) }

            if (conditions.length > 0) {
                return this.dataitems.filter((item) => {
                    return conditions.every((condition) => {
                        return condition(item)
                    })
                })
            }

            return this.dataitems
        },

        filteroscode(item) {
            return (item.oscode) ? item.oscode.toLowerCase().includes(this.txtoscode.toLowerCase()) : null
        },

        filterosdesc(item) {
            return (item.osdesc) ? item.osdesc.toLowerCase().includes(this.txtosdesc.toLowerCase()) : null
        },

        newItem() {
            this.editeditem = Object.assign({}, this.newitem)
            this.formmodel = Object.assign({}, this.newitem)
            this.mode = 'NEW'
            this.$refs.fldfirst.focus()
        },

        editItem(itm) {
            this.editeditem = Object.assign({}, itm)
            this.formmodel = Object.assign({}, itm)
            this.mode = 'EDIT'
            this.$refs.fldfirst.focus()
        },

        deleteItem(itm) {
            this.deleteditem = Object.assign({}, itm)
            this.deleteditem.no = this.dataitems.indexOf(itm) + 1
            this.dlgdelete = true
        },

        canceldelete() {
            this.deleteditem = Object.assign({}, this.newitem)
            this.dlgdelete = false
        },

        cancel() {
            this.formmodel = Object.assign({}, this.newitem)
            this.mode = ''
        },

        savethis() {
            var targetPath = ''

            if (!this.isformvalid) {
                this.msg = 'Data invalid. Cannot continue with add or update.'
                this.sberrmsg = true
                this.cancel()
                return
            }

            var data = new FormData()
            if (this.mode === 'NEW') {
                targetPath = '/admin/system-order-status/add'
                data.append('oscode', this.formmodel.oscode)
                data.append('osdesc', this.formmodel.osdesc)
            }

            if (this.mode === 'EDIT') {
                targetPath = '/admin/system-order-status/update'
                data.append('id', this.editeditem.id)
                data.append('oscode', this.formmodel.oscode)
                data.append('osdesc', this.formmodel.osdesc)
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                        this.cancel()
                    }
                }
            })

        },

        deletethis() {
            var targetPath = '/admin/system-order-status/delete'
            var data = {
                id: this.deleteditem.id,
            }

            axios.post(targetPath, data)
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    this.canceldelete()
                    if (rtn.status === 'OK') {
                        this.msg = rtn.message
                        this.sbmsg = true
                        this.initialize()
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                }
            })
        },

        deleteselected() {
            var targetPath = '/admin/system-order-status/deleteselected'
            var data = new FormData()

            data.append('todelete', JSON.stringify(this.selecteditems))

            axios.post(targetPath, data, {
                headers: {
                    'ContentType': 'application/json' // coz we're passing an array
                }
            })
            .then((resp) => {
                if (resp.data) {
                    var rtn = resp.data
                    if (rtn.status === 'OK') {
                        this.initialize()
                        this.msg = rtn.message
                        this.sbmsg = true
                    } else {
                        this.msg = rtn.error
                        this.sberrmsg = true
                    }
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                        this.selecteditems = [] // reset
                    })
                }
            })
        },

        execmfunc() {
            if (this.selmultifunc === 'MDEL') { // multiple delete
                // check if anything was selected
                if (this.selecteditems.length === 0) {
                    this.msg = 'No records are selected for deletion'
                    this.sberrmsg = true
                    this.$nextTick(() => {
                        this.selmultifunc = null // reset
                    })
                    return
                }
                this.deleteselected()
            }
        },
    },
}
</script>
